import LocalAtmIcon from '@material-ui/icons/LocalAtm';

export const PaidMediaIcon = LocalAtmIcon;
